import { __module as valuePropType } from '../../../../../_virtual/value-prop-type.js';
import { __require as requireUtils } from '../utils/index.js';

var hasRequiredValuePropType;

function requireValuePropType () {
	if (hasRequiredValuePropType) return valuePropType.exports;
	hasRequiredValuePropType = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = valuePropType;

		var _utils = requireUtils();

		/**
		 * @ignore
		 * @param {Object} props
		 * @return {?Error} Return Error if validation fails
		 */
		function valuePropType(props, propName) {
		  var maxValue = props.maxValue,
		      minValue = props.minValue;

		  var value = props[propName];

		  if (!(0, _utils.isNumber)(value) && (!(0, _utils.isObject)(value) || !(0, _utils.isNumber)(value.min) || !(0, _utils.isNumber)(value.max))) {
		    return new Error('"' + propName + '" must be a number or a range object');
		  }

		  if ((0, _utils.isNumber)(value) && (value < minValue || value > maxValue)) {
		    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
		  }

		  if ((0, _utils.isObject)(value) && (value.min < minValue || value.min > maxValue || value.max < minValue || value.max > maxValue)) {
		    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
		  }
		}
		module.exports = exports['default'];
		
	} (valuePropType, valuePropType.exports));
	return valuePropType.exports;
}

export { requireValuePropType as __require };
